import { addLoader } from '../../../core/js/components/gridComponent';

import template from 'category-paging.j2';
import { generate } from '../../../core/js/utils/componentUtils';

export function onStateChange(store) {
    this.render(store, this);
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents() {
    $(document).on(this.scopedEvent('touchend click'), '.js-pagination__arrow--previous, .js-pagination__arrow--next', addLoader);
}

/**
* Bootstrap the component onto the page
* @param {object} store - The store
* @param {object} overrides - The overrides object
* @returns {undefined}
*/
export function init(store, overrides = {}) {
    const config = {
        name: 'paginationComponent',
        attachEvents: attachEvents,
        watch: 'category.queryString',
        templateLocation: '.dom-paging-top .dom-paging',
        template: template,
        onStateChange: onStateChange
    };

    return generate(config, store, overrides);
}
